import classNames from 'classnames';
import { ArrowRight, ThoughtsNegative, ThoughtsPositive } from '../icons';
import { usePressed } from '../usePressed';
import { LabelBreadcrumbsActive } from './LabelBreadcrumbsActive';
import { ThoughtBubble } from './ThoughtBubble';

type Props = {
    type: 'positive' | 'negative';
    thoughts: string[];
    onClick: () => void;
};
export function ThoughtColumn({ type, thoughts, onClick }: Props) {
    const { isPressingInside, pointerEvents } = usePressed();
    const isDisabled = !onClick;
    const effectivePress = isDisabled ? false : isPressingInside;
    const config =
        type == 'negative'
            ? {
                  title: 'Det der presser dig',
                  icon: <ThoughtsNegative className="my-10" />,
                  foregroundColor: 'bg-dark-red',
                  backgroundColor: 'bg-falck-red-10p',
                  backgroundColorPressed: 'bg-falck-red-20p',
              }
            : {
                  title: 'Det der hjælper dig',
                  icon: <ThoughtsPositive className="my-10" />,
                  foregroundColor: 'bg-vibrant-blue',
                  backgroundColor: 'bg-vibrant-blue-10p',
                  backgroundColorPressed: 'bg-vibrant-blue-20p',
              };
    return (
        <div className="flex flex-col items-center">
            <ThoughtBubble>
                <LabelBreadcrumbsActive color="text-dark-red">
                    {config.title}
                </LabelBreadcrumbsActive>
            </ThoughtBubble>
            {config.icon}
            <div
                className={classNames(
                    {
                        'bg-interactive-surface': isDisabled,
                        [config.backgroundColor]:
                            !isDisabled && !effectivePress,
                        [config.backgroundColorPressed]:
                            !isDisabled && effectivePress,
                    },
                    'inline-block rounded-full p-10',
                )}
            >
                <div style={{ height: thoughts.length * 30 + 'px' }} />
                <div
                    className={classNames(
                        config.foregroundColor,
                        'flex aspect-square w-[44px] items-center justify-center rounded-full',
                        { 'opacity-30': isDisabled },
                    )}
                    onClick={onClick}
                    {...pointerEvents}
                >
                    <ArrowRight className="text-white" />
                </div>
            </div>
        </div>
    );
}
